"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleAppointmentFixedMobileFooter = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const LoadingBookingOptions_1 = require("./LoadingBookingOptions");
const provider_components_1 = require("@kyruus/provider-components");
const AvailableWithinDays_1 = __importDefault(require("./AvailableWithinDays"));
const messages_1 = __importDefault(require("../../lib/messages"));
const react_intl_1 = require("react-intl");
const utilities_1 = require("./utilities");
const Switch_1 = require("../Switch");
const types_1 = require("../../types");
function ScheduleAppointmentFixedMobileFooter(props) {
    const bookingStrategy = (0, utilities_1.getBookingStrategy)(props.config, props.provider);
    return (react_1.default.createElement(styles_1.StyledScheduleAppointmentFixedMobileFooter, null,
        react_1.default.createElement(Switch_1.Switch, { on: bookingStrategy },
            react_1.default.createElement(Switch_1.Case, { when: types_1.BookingStrategies.Button },
                react_1.default.createElement(styles_1.BookingSectionContainer, { "aria-label": props.intl.formatMessage(messages_1.default.bookingHeader), showBorder: false },
                    react_1.default.createElement(LoadingBookingOptions_1.LoadingBookingOptions, { loading: props.loadingBookingInfo }),
                    !props.loadingBookingInfo && (react_1.default.createElement(styles_1.BookingButtonModeBookingContent, null,
                        react_1.default.createElement(styles_1.BookingButtonWrapper, null,
                            react_1.default.createElement(provider_components_1.ProviderBookingButton, { provider: props.provider, modalDisplayConfig: props.config.modal_display || {}, onClick: props.onBook, href: props.bookOnlineUrl })),
                        (0, utilities_1.showAvailableWithinDays)(props) && (react_1.default.createElement(AvailableWithinDays_1.default, { availabilityDensityBest: props.availabilityDensityBest })))))),
            react_1.default.createElement(Switch_1.Default, null, "Not Implemented"))));
}
const IntlScheduleAppointmentFixedMobileFooter = (0, react_intl_1.injectIntl)(ScheduleAppointmentFixedMobileFooter);
exports.ScheduleAppointmentFixedMobileFooter = IntlScheduleAppointmentFixedMobileFooter;
//# sourceMappingURL=ScheduleAppointmentFixedMobileFooter.js.map